<template>
  <el-dialog
    v-if="dialogVisible"
    :visible.sync="dialogVisible"
    title="首次结算日期说明"
    width="40%"
    append-to-body
  >
    <div class="dialog-content">
      <div style="margin-bottom: 10px"
        >首次结算日期为空:系统不能自动生成应收费用清单,结算的时候需要手动生成。</div
      >
      <div>首次结算期不为空:系统以首次结算日期为基准,按计费周期自动生成应收费用清单。</div>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" @click="cancelHandler" size="small">我知道了</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
  export default {
    name: 'FirstSettlementDialog',
    data() {
      return {
        dialogVisible: false,
      };
    },
    methods: {
      openModal() {
        this.dialogVisible = true;
      },
      cancelHandler() {
        this.dialogVisible = false;
      },
    },
  };
</script>

<style lang="scss" scoped></style>
